export const DSRKafuU = {
  name: '虾仁芹菜 | 神意之地',
  link: 'https://github.com/dsrkafuu',
};

export const j0sh77 = {
  name: 'Jimmy Lolo | Malboro',
  link: 'https://na.finalfantasyxiv.com/lodestone/character/6170027/',
};
